// components/Admin/EmoticonManager/EmoticonFormModal.jsx
import React, { useState } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    TextField, Button, FormControlLabel, Checkbox, Box,
    Typography, FormControl, FormLabel, Radio, RadioGroup,
    useMediaQuery, useTheme,
} from '@mui/material';
import api from '../../../api/axios';

const getFullImageUrl = (url) =>
    url?.startsWith('http') ? url : `https://sandle.it.com${url}`;

const EmoticonFormModal = ({ open, onClose, onSuccess }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const [name, setName] = useState('');
    const [price, setPrice] = useState('');
    const [stock, setStock] = useState('');
    const [isUnlimited, setIsUnlimited] = useState(true);
    const [image, setImage] = useState(null);
    const [emojiText, setEmojiText] = useState('');
    const [type, setType] = useState('image');

    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append('name', name);
        formData.append('price', parseInt(price || 0));
        formData.append('is_unlimited', isUnlimited ? 'true' : 'false');
        formData.append('stock', isUnlimited ? 0 : parseInt(stock || 0));
        formData.append('is_active', 'true');
        if (type === 'image' && image) formData.append('image', image);
        if (type === 'text' && emojiText.trim()) formData.append('emoji_text', emojiText.trim());

        try {
            await api.post('/api/management/emoticons/', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            if (onSuccess) onSuccess();
            onClose();
        } catch (err) {
            console.error(err.response?.data || err.message);
            alert('등록 실패');
        }
    };

    const isSubmitDisabled =
        !name.trim() ||
        !price ||
        (type === 'image' && !image) ||
        (type === 'text' && !emojiText.trim());

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle>이모티콘 등록</DialogTitle>
            <DialogContent dividers>
                <Box
                    component="form"
                    onSubmit={handleSubmit}
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 2,
                        mt: 1,
                    }}
                >
                    <TextField
                        label="이름"
                        value={name}
                        onChange={e => setName(e.target.value)}
                        required
                        fullWidth
                    />
                    <TextField
                        label="가격"
                        type="number"
                        value={price}
                        onChange={e => setPrice(e.target.value)}
                        required
                        fullWidth
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={isUnlimited}
                                onChange={(e) => setIsUnlimited(e.target.checked)}
                            />
                        }
                        label="무제한"
                    />
                    <TextField
                        label="수량"
                        type="number"
                        value={stock}
                        onChange={e => setStock(e.target.value)}
                        disabled={isUnlimited}
                        required={!isUnlimited}
                        fullWidth
                    />
                    <FormControl>
                        <FormLabel>이모티콘 타입</FormLabel>
                        <RadioGroup
                            row={!isMobile}
                            value={type}
                            onChange={e => setType(e.target.value)}
                        >
                            <FormControlLabel value="image" control={<Radio />} label="이미지" />
                            <FormControlLabel value="text" control={<Radio />} label="텍스트" />
                        </RadioGroup>
                    </FormControl>
                    {type === 'text' && (
                        <TextField
                            label="텍스트 이모지 (😊 등)"
                            value={emojiText}
                            onChange={e => setEmojiText(e.target.value)}
                            inputProps={{ maxLength: 5 }}
                            fullWidth
                        />
                    )}
                    {type === 'image' && (
                        <Button variant="outlined" component="label" fullWidth={isMobile}>
                            이미지 업로드
                            <input type="file" hidden onChange={e => setImage(e.target.files[0])} />
                        </Button>
                    )}
                    <Box
                        sx={{
                            minWidth: 80,
                            maxWidth: 100,
                            height: 100,
                            border: '1px dashed #ccc',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderRadius: 1,
                            mx: isMobile ? 'auto' : 0,
                        }}
                    >
                        {type === 'image' && image ? (
                            <img
                                src={image instanceof File ? URL.createObjectURL(image) : getFullImageUrl(image)}
                                alt="미리보기"
                                style={{ maxWidth: '100%', maxHeight: '100%' }}
                            />
                        ) : type === 'text' && emojiText.trim() !== '' ? (
                            <Typography fontSize={36}>{emojiText}</Typography>
                        ) : (
                            <Typography variant="caption" color="text.secondary">미리보기</Typography>
                        )}
                    </Box>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>취소</Button>
                <Button variant="contained" onClick={handleSubmit} disabled={isSubmitDisabled}>
                    등록
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default EmoticonFormModal;
